import { cn } from '~/lib/utils';

export function HorizontalRule({ className }: { className?: string }) {
  return <hr className={cn('border m-0 h-px w-full -rotate-1', className)} />;
}
